export default __webpack_public_path__ + "static/media/ConnectionIconRed.85c294ef.svg";